import i18n from "@/i18n";
import axios from "axios";
import apiService from "@/services/apiService";
import { v4 as uuidv4 } from "uuid";
import {
  DeviceConfiguration,
  DeviceConfigurationDeserializer,
  DeviceUpdates,
  DeviceUpdatesDeserializer,
} from "@/models/deviceConfiguration";
import { WizardConfiguration } from "@/models/wizardConfiguration";

const connectToRoom = async (
  pin: string,
  update: boolean
): Promise<DeviceConfiguration> => {
  const res = await axios.get(apiService.wizard.connect() + "/" + pin, {
    params: { configurationType: update ? 2 : 1 },
  });
  if (res.data.isPinValid == false) {
    throw new Error(i18n.t("roomWizard.errors.invalidPin") as string);
  }
  if (res.data.deviceConnected == false) {
    throw new Error(i18n.t("roomWizard.errors.deviceNotConnected") as string);
  }
  if (
    res.data.deviceConfiguration.status == "WebWizardCompleted" ||
    res.data.deviceConfiguration.status == "ClientWizardRunning" ||
    res.data.deviceConfiguration.status == "ClientWizardCompleted"
  ) {
    throw new Error(
      i18n.t("roomWizard.errors.wizardStatus") +
        res.data.deviceConfiguration.status
    );
  }
  return DeviceConfigurationDeserializer(res.data.deviceConfiguration);
};

const reserveSeat = async (
  deviceConfigurationId: string,
  licensePackageId: string
): Promise<any> => {
  const res = await axios.post(apiService.wizard.reserveSeat(), {
    DeviceConfigurationId: deviceConfigurationId,
    LicensePackageId: licensePackageId,
  });
  return res.data;
};

const checkUpdates = async (
  deviceConfiguration: DeviceConfiguration
): Promise<DeviceUpdates | undefined> => {
  const res = await axios.post(apiService.wizard.checkUpdates(), {
    label: deviceConfiguration.label,
    podReleaseTypeKeyId: deviceConfiguration.releaseType,
    currentVersion: deviceConfiguration.installedVersion,
    releaseChannel: deviceConfiguration.releaseChannel,
    //"useFastChannel: false //[true/false] // (opzionale, non necessario in questo momento dato che non gestito da wizard)
  });
  return res.data ? DeviceUpdatesDeserializer(res.data) : undefined;
};

const updateDevice = async (
  deviceConfiguration: DeviceConfiguration,
  downloadUrl: string
): Promise<any> => {
  const res = await axios.post(apiService.wizard.configurationEvents(), {
    EventId: uuidv4(),
    DeviceConfigurationId: deviceConfiguration.deviceConfigurationId,
    EventKey: "update-required",
    EventData: {
      downloadUrl: downloadUrl,
    },
  });
  return res.data;
};

const sendConfig = async (
  deviceConfiguration: DeviceConfiguration,
  wizardConfiguration: WizardConfiguration
): Promise<any> => {
  const res = await axios.post(apiService.wizard.sendConfiguration(), {
    DeviceConfigurationId: deviceConfiguration.deviceConfigurationId,
    JsonConfiguration: wizardConfiguration,
  });
  return res.data;
};

export default {
  connectToRoom,
  reserveSeat,
  checkUpdates,
  updateDevice,
  sendConfig,
};
